import {Column} from "../../../hooks/table";

export function computeTotalFractionalWidth(columns: Column[]): number {
  return columns.reduce((acc, column) => acc + (column.fractionalWidth ?? 1), 0);
}
